var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlThumbnailGeneric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 56,
    rx: 6,
    fill: "#CBD8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 55,
    rx: 5.5,
    stroke: "#2A2A2A",
    strokeOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 14.668V22.668C50.6667 23.3752 50.9476 24.0535 51.4477 24.5536C51.9478 25.0537 52.6261 25.3346 53.3333 25.3346H61.3333V38.668C61.3333 39.3752 61.0524 40.0535 60.5523 40.5536C60.0522 41.0537 59.3739 41.3346 58.6667 41.3346H40.6667C39.9594 41.3346 39.2811 41.0537 38.781 40.5536C38.281 40.0535 38 39.3752 38 38.668V17.3346C38 16.6274 38.281 15.9491 38.781 15.449C39.2811 14.9489 39.9594 14.668 40.6667 14.668H50.6667ZM52.6667 15.3346V22.668C52.6667 22.8448 52.7369 23.0143 52.8619 23.1394C52.987 23.2644 53.1565 23.3346 53.3333 23.3346H60.6667L52.6667 15.3346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlThumbnailGeneric);
export default __webpack_public_path__ + "static/media/il-thumbnail-generic.cdb1e10d44effb3db491af45e5807968.svg";
export { ForwardRef as ReactComponent };